import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { User } from '../../models/user';
import { Router } from '@angular/router';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  user: User = new User();
  message = '';
  signInForm: FormGroup;
  loader = false;

  constructor(
    private _auth: AuthService,
    private _router: Router,
    private fb: FormBuilder
  ) {
    this.signInForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  login(): void {
    if (!this.signInForm.valid) {
      return;
    }
    this.loader = true;
    const formValue = this.signInForm.value;
    this._auth.login(formValue).subscribe(() => {
        this._router.navigate(['/']);
      }, error => {
        this.message = error.message;
        this.loader = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts